
(window as any).runtime = {
  // 运行环境 development ｜ production
  env: process.env,
  // 运行版本
  version: process.version,
};
